import React from 'react';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import PhotoIcon from '@material-ui/icons/Photo';
import PropTypes from 'prop-types';


function GalleriesAndVideosCountSection(props) {
  const { isGuestHomePage, mediaCount } = props;
  const { totalPublicGalleries: galleriesCount, totalPublicVideos: videosCount } = mediaCount;
  const videoText = videosCount !== 1 ? 'Videos' : 'Video';
  const galleryText = galleriesCount !== 1 ? 'Galleries' : 'Gallery';

  const formatMediaCount = (mediaCount) => {
    if (mediaCount > 99) {
      return '99+';
    }

    return mediaCount || 0;
  };

  if (!isGuestHomePage) {
    return null;
  }

  return (
    <span id="galleries-count-guest">
      <span
        className="show-count"
      >
        <PlayCircleFilledIcon /> {formatMediaCount(videosCount)} {videoText}
      </span>
      <span
        className="show-count"
      >
        <PhotoIcon /> {formatMediaCount(galleriesCount)} {galleryText}
      </span>
    </span>
  );
}

export default React.memo(GalleriesAndVideosCountSection);


GalleriesAndVideosCountSection.propTypes = {
  isGuestHomePage: PropTypes.bool.isRequired,
  mediaCount: PropTypes.shape({
    totalPublicGalleries: PropTypes.number.isRequired,
    totalPublicVideos: PropTypes.number.isRequired,
  }).isRequired,
};


GalleriesAndVideosCountSection.defaultProps = {
  isGuestHomePage: false,
  mediaCount: {
    totalPublicGalleries: 0,
    totalPublicVideos: 0,
  },
};
